import { createPinia } from "pinia";

const pinia = createPinia();

//import { useBadgesData } from "@/modules/4.badges/stores/badgesDataStore";
//const s = useBadgesData(pinia)


export default pinia;